import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSongGenre } from 'redux/actions/songActions'
import { MEDIA_TYPES } from 'util/postUtils'
import genres from '../../assets/csv/genres.csv'
import topics from '../../assets/csv/topics.csv'
import ChooseFromSelect from './ChooseFromSelect'
/* Genres from 500 and above are Video topics */
export const VIDEO_TOPICS_BASE = 500

/**
 * 
 * @param {*} video If true use the topics list, otherwise genres 
 * @returns 
 */
export default function Genres() {
    const [genreList, setGenreList] = useState()
    const { genre, mediaIcons } = useSelector(state => state.song)
    const dispatch = useDispatch()
    const hasMediaType = (mediaType) => {
        for (const entry of mediaIcons) {
            const { mimeType } = entry
            if (mediaType.includes(mimeType)) {
                return true
            }
        } return false
    }
    const formatGenres = () => {
        let genreArray = []
        fetch(hasMediaType(MEDIA_TYPES.VIDEO) ? topics : genres).then(row => row.text()).then(text => {
            genreArray = text.split('\n')
            setGenreList(genreArray)
        })
    }
    const displayGenres = () => {
        if (genreList) {
            //console.log(`Genres video ${hasMediaType(MEDIA_TYPES.VIDEO)}`, genreList)
            return (
                <div style={{ paddingTop: '1em', paddingBottom: '1em', display: 'flex', justifyContent: 'center' }}>
                    <ChooseFromSelect
                        choice={genre}
                        choiceList={genreList}
                        label={`${hasMediaType(MEDIA_TYPES.VIDEO) ? 'Topic ' : 'Genre '}`}
                        singleLine
                        commaDelimited={true}
                        onSelected={(value) => dispatch(setSongGenre(parseInt(value.id)))}
                    />
                </div>
            )
        }
    }

    useEffect(() => {
        formatGenres()
    }, [mediaIcons])
    return displayGenres()
}